NumberService = ->
  limitFractional: (number, fractionLimit=2) ->
    return unless number
    numberParts = number.toFixed(fractionLimit).match(/\d+/g)
    numberParts.join(".")

  getFractionalPart: (number, fractionLimit=2) ->
    return unless number
    numberParts = number.toString().match(/\d+/g)
    if numberParts? and numberParts.length > 1
      '.' + numberParts[1].substring(0, fractionLimit)
    else
      ".00"

  getIntegerPart: (number) ->
    return unless number
    matches = number.toString().match(/\d+/g)
    return matches?[0] or null

module.exports = NumberService


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/number/number-service.coffee